export const state = {
	notifications: null
}



// WEBPACK FOOTER //
// ./src/store/modules/Notifications/state.js